import styled from 'styled-components'

export const ContainerPontosAdicionados = styled.div`
  width: 100%;
  height: auto;

  .ant-collapse-content-box {
    padding: 10px !important;
  }

  /* Cabeçalho do painel: rótulo à esquerda, cor da análise à direita. */
  .adicionados__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    /* permite o rótulo encolher e aplicar ellipsis em nomes longos */
    min-width: 0;
  }

  .adicionados__rotulo {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    font-size: 13px;
  }

  .adicionados__rotulo__cor {
    width: 12px;
    height: 12px;
    background: lightgray;
    border-radius: 100%;
  }

  .adicionados__rotulo__analise {
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .adicionados__rotulo__separador {
    color: #bdbdbd;
    font-weight: 400;
  }

  .adicionados__rotulo__profundidade {
    font-weight: 600;
    color: #757575;
    white-space: nowrap;
  }

  /* Botão do olho: mesmo visual do modal "Ver malha". Ativo, assume a cor da
     análise — assim o usuário liga o destaque e vê a cor correspondente. */
  .button__eye {
    padding: 8px;
    border-radius: 6px;
    width: 35px;
    /* não encolhe quando o nome da análise é longo */
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #5da57d;
    border: 2px solid #5da57d;
    cursor: pointer;
  }

  .button__eye:hover,
  .button__eye:is([data-active='true']) {
    background-color: var(--cor-do-item);
    border: 2px solid var(--cor-do-item);
    color: white;
  }

  .container__adicionados {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 2px solid #d9d9d9;
    padding: 10px;
    border-radius: 8px;
    gap: 8px;
  }

  .header__adicionados {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .points-title {
    color: #757575;
    font-size: 12px;
    font-weight: 700;
    margin: 0;
    padding: 0;
  }

  .points-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .point-card {
    background-color: var(--cor-do-item);
    color: white;
    border: 2px solid var(--cor-do-item);
    font-weight: 700;
    font-size: 12px;
    width: 30px !important;
    height: 30px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
  }
`
